import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "panel"
}

import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { AppStore } from '@/store';
import { router } from '@/router';
import { useGettext } from '@jshmrtn/vue3-gettext';
import auth from '@/core/Auth';
import PageLayout from '@/core/components/PageLayout.vue';
import ResourceTable from '@/core/components/resource/ResourceTable.vue';
import Column from '@/core/components/resource/Column';
import ActionColumn from '@/core/components/resource/ActionColumn';
import { Customer } from '@/modules/customer/Customer';
import { User } from '@/modules/user/User';
import { useCustomerRouteLoader } from '@/modules/customer/pages/userCommon';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserIndex',
  setup(__props) {

const { $gettext, interpolate } = useGettext();
const store = useStore<AppStore>();
const authUser = computed<User | null>(() => store.state.authenticatedUser);
const resource = ref();
const customer = ref<Customer>();
const pageTitle = computed(() => interpolate(
	$gettext('Användare för %{ name }'),
	{name: customer.value?.name || ''},
));
const userToDelete = ref<User>();

useCustomerRouteLoader(resource, customer);

const actionColumn = new ActionColumn<User>()
	.withEditLink((u) => ({ name: 'customer.user.edit', params: { id: u.id } }))
	.withDeleteLink((u: User) => {
		userToDelete.value = u;
	})
;

if (authUser.value?.type === 'MASTER') {
	actionColumn.withButton('user-secret', 't-neutral', (u) => {
		auth.impersonate(u.id)
			.then(() => {
				router.push({ name: 'dashboard' });
			})
		;
	});
}

const columns = [
	new Column<User>($gettext('Namn'), 'name', 'u.name', '+'),
	new Column<User>($gettext('E-post'), 'email', 'u.email'),
	actionColumn,
];

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(PageLayout, { "page-title": pageTitle.value }, {
    "header-actions": _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_RouterLink, {
        to: {name: 'customer.index'},
        class: "button"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode(" Tillbaka ", -1)
        ]))]),
        _: 1
      })), [
        [_directive_translate]
      ]),
      (customer.value)
        ? _withDirectives((_openBlock(), _createBlock(_component_RouterLink, {
            key: 0,
            to: {
				name: 'customer.user.create',
				params: {
					customer_id: customer.value.id,
				},
			},
            class: "button"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode(" Ny användare ", -1)
            ]))]),
            _: 1
          }, 8, ["to"])), [
            [_directive_translate]
          ])
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      (resource.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(ResourceTable, {
              resource: resource.value,
              columns: columns,
              "delete-title": _unref($gettext)('Ta bort användare'),
              "delete-name-key": "name",
              "to-delete": userToDelete.value,
              "onUpdate:toDelete": _cache[0] || (_cache[0] = ($event: any) => ((userToDelete).value = $event))
            }, null, 8, ["resource", "delete-title", "to-delete"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["page-title"]))
}
}

})